import { render, staticRenderFns } from "./ThanksCards.vue?vue&type=template&id=ccade328&"
import script from "./ThanksCards.vue?vue&type=script&lang=js&"
export * from "./ThanksCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports